module.exports = "<tr class=\"items-td flex\" id=weekNum> </tr>";


//////////////////
// WEBPACK FOOTER
// ./app/components/calendar/calendar.main/calendar.month/calendar.table.body/calendar.table.body.html
// module id = 4936
// module chunks = 50